export { default as MainC } from 'modules/penalizaciones/components/lista';
export { default as PenalizacionesUsuarioC } from 'modules/penalizaciones/components/penalizacionesUsuario';
//export {default as LogsC} from 'modules/registros/components/logs';



// WEBPACK FOOTER //
// src/modules/penalizaciones/component.js